import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import styles from "./MissionsList.module.scss";
import moment from "moment/moment";
import { useSelector, useDispatch } from "react-redux";
import {useNavigate} from "react-router-dom";
import {PATH_IDO_ADMINISTRATION, PATH_MISSION_ADMINISTRATION, PATH_RAFFLE_ADMINISTRATION} from "../../App";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import {DataGrid} from "@mui/x-data-grid";
import toast from "react-hot-toast";
import {errorToast} from "../../helpers/toastCSS";
import {PROD_API_URL} from "../../constants/constants";

const columns = [
  { field: 'name', headerName: 'Name', flex: 3 },
  { field: 'prizes', headerName: 'Prizes', flex: 1 },
  { field: 'totalParticipants', headerName: 'Total Participants', width: 140 },
  { field: 'poolName', headerName: 'Pool Name', width: 100 },
  { field: 'production', headerName: 'Production', width: 100 },
  { field: 'isPermanent', headerName: 'Open Permanently', width: 100 },
  { field: 'missionStartTime', headerName: 'Mission Start Time', flex: 2},
  { field: 'missionEndTime', headerName: 'Mission End Time', flex: 2},
];

export const NEW_MISSION_ID = 'newMission'
const MissionsList = () => {
  const navigate = useNavigate();
  const adminUser = useSelector(state => state.userData.adminUser)

  const [rows, setRows] = useState();

  useEffect( ()=>{
    const fetchMissions = async () => {
      fetch(PROD_API_URL +"/missions/", {
        "method": "GET",
        "headers": {"content-type": "application/json", "accept": "*"},
      }).then(res=>res.json())
        .then((result)=>{
          parseResult(result)
        });
    }

    fetchMissions();
  },[]);

  const parseResult = (result) => {
    const finalResult = result.data.sort((a, b) => a.contributionStartTime - b.contributionStartTime).reverse().map(mission => {
      return ({
        id: mission.id,
        name: mission.name,
        prizes: mission.prizes,
        totalParticipants: mission.totalParticipants,
        poolName: mission.poolName,
        production: mission.production ? 'Yes' : 'No',
        isPermanent: mission.isPermanent ? 'Yes' : 'No',
        missionStartTime: moment.unix(mission.missionStartTime).format('YYYY-MM-DD , h:mm A'),
        missionEndTime: moment.unix(mission.missionEndTime).format('YYYY-MM-DD , h:mm A'),
      })
    })

    setRows(finalResult)
  }

  const redirectToCreateOrEdit = (id) => {
    if (adminUser.canEditRaffle !== true) {
      return toast('You do not have access to edit Raffles', errorToast);
    }

    navigate(`${PATH_MISSION_ADMINISTRATION}/${id}`);
  }

  return (
    <main >
       <div className={styles.idoAdminContainer}>
         <div className={styles.idoTableContainer}>
           { !rows && <LoadingSpinner local />}
           { rows &&
             <DataGrid
               rows={rows}
               onCellDoubleClick={(params) => redirectToCreateOrEdit(params.row.id)}
               columns={columns}
               initialState={{
                 pagination: {
                   paginationModel: { pageSize: 25 },
                 },
               }}
               pageSizeOptions={[5, 10, 25]}
             />

           }
         </div>
         <div className={styles.idoTableFooter}>
           <Button text="CREATE NEW MISSION" buttonType={BUTTON_TYPE_SECONDARY} onClick={() => redirectToCreateOrEdit(NEW_MISSION_ID)} />
         </div>
       </div>
    </main>

  );
}

export default MissionsList;
